import { UserPermission } from '@cobliteam/common-types/';

const CostsPermissions = {
  VIEW_FLEET_EXPENSES: UserPermission.VIEW_FLEET_EXPENSES,
};

export default CostsPermissions;
